import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M14.899 3.957a.6.6 0 0 1-.2 1.148c-5.57.927-5.668 8.889.037 9.792.611.099.724.894.115 1.166-4.48 1.989-9.71-1.167-9.71-6.063 0-4.913 5.27-8.072 9.758-6.043Zm-2.35.611C9.227 4.267 6.386 6.784 6.386 10c0 3.214 2.841 5.73 6.163 5.429a6.093 6.093 0 0 1 0-10.86Z" fill="currentColor" />' }
  })
);